import { getDUID } from '../libs/getDUID';

export function useDUID() {
  return getDUID();
}
